/***
 *
 *   PROJECT SELECTOR STYLES
 *   Ported from ui-reference/src/components/layouts/project-switcher.tsx.
 *
 *   The previous version positioned itself absolutely over the header
 *   (`absolute top-1/2 -translate-y-2/4 right-0`); it is now a normal flex child
 *   of the top bar's trailing slot.
 *
 **********/

const Style = {
    trigger: `flex items-center gap-2 rounded-md border bg-surface py-1.5 pl-1.5 pr-2
    text-sm font-medium text-text-primary transition-colors hover:bg-muted
    focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring md:pl-2 md:pr-3`,

    name: 'max-w-[140px] truncate',
    chevron: 'shrink-0 text-text-muted',
    allIcon: 'shrink-0 text-text-muted',

    itemName: 'min-w-0 flex-1 truncate',
    // The menu row is tight, so the badge drops its default padding and casing.
    itemBadge: 'px-1.5 py-0 text-[10px] normal-case',
};

export default Style;
